import {MaintainedSource} from './MaintainedSource.ts';
import type {YomiriManga,YomiriChapter} from '../../types/extension.ts';
export class NovelCoolSource extends MaintainedSource {
    readonly id = 'novelcool';
    readonly name = 'NovelCool';
    readonly website = 'https://es.novelcool.com';
    protected async text(url: string, form?: URLSearchParams): Promise<string> {
        const response = await this.http.text({sourceId: this.id, url, method: form ? 'POST' : 'GET',
            body: form?.toString(), headers: {'User-Agent': 'Yomiri/1.0', ...(form ? {'Content-Type': 'application/x-www-form-urlencoded'} : {})},
            responseType: 'text', credentials: 'omit', cache: {ttlMs: 300000, scope: 'public'}});
        if (response.status >= 400 || response.classification === 'challenge') throw new Error(`NovelCool: HTTP ${response.status}, ${response.classification}`);
        return response.body;
    }
    private async catalog(url: string) { const d = this.dom(await this.text(url)); const mangas = Array.from(d.querySelectorAll('.book-list .book-item:not(:has(.book-type-novel))')).map(e => this.manga(this.absolute(e.querySelector('a')!.getAttribute('href')!), e.querySelector('.book-pic')?.getAttribute('title') || '', this.absolute(e.querySelector('img')?.getAttribute('lazy_url') || e.querySelector('img')?.getAttribute('src') || '', url))); return { mangas, hasNextPage: !!d.querySelector('.page-nav .next') }; }
    readonly supportsNewlyAdded = true;
    getPopular() { return this.catalog(`${this.website}/category/new_list.html`); }
    getLatest() { return this.getPopular(); }
    async search(q: string, page = 1) { if (page > 1)
        return { mangas: [], hasNextPage: false }; const rows = JSON.parse(await this.text(`${this.website}/ajax/search/?term=${encodeURIComponent(q)}`, new URLSearchParams())) as {
        url: string;
        name: string;
        cover: string;
        is_novel: boolean;
    }[]; return { mangas: rows.filter(e => !e.is_novel).map(e => this.manga(e.url, e.name, e.cover)), hasNextPage: false }; }
    async getManga(id: string) { const d = this.dom(await this.text(id)); return { ...this.manga(id, d.querySelector('h1.bookinfo-title')?.textContent?.trim() || '', this.absolute(d.querySelector('.bookinfo-pic-img')?.getAttribute('src') || '', id)), description: d.querySelector('.bk-summary-txt')?.textContent?.trim() }; }
    async getChapters(id: string) {
        const d = this.dom(await this.text(id));
        const chapters = Array.from(d.querySelectorAll('.chapter-item-list a')).flatMap(e => {
            const url = new URL(e.getAttribute('href') || '', id);
            if (url.hostname !== 'es.novelcool.com' || !/^\/chapter\/.+\/\d+(?:\.html|\/)$/.test(url.pathname)) return [];
            // Trailing-slash URLs can redirect to an advertising gateway.
            url.pathname = url.pathname.replace(/\/$/, '.html');
            return [this.chapter(url.href, id, e.getAttribute('title') || e.textContent?.trim() || 'Capítulo')];
        });
        if (!chapters.length && d.querySelector('.chapter-item-list a')) throw new Error('NovelCool devolvió enlaces intermedios en lugar de capítulos. Volvé a comprobar la conexión con la versión actual de Yomiri Bridge.');
        return chapters;
    }
    async getPages(id: string) {
        // NovelCool splits chapters into batches of ten images. sl-page also
        // appears in the chapter selector, so only follow the current chapter.
        const url = id.replace(/\/(\d+)(?:-\d+-\d+)?(?:\.html|\/)$/, '/$1-10-1.html');
        const first = this.dom(await this.text(url));
        const pages = new Set([url]);
        const chapterPath = new URL(url).pathname.replace(/-10-1\.html$/, '');
        for (const option of Array.from(first.querySelectorAll('select.sl-page option'))) {
            const value = option.getAttribute('value');
            if (!value) continue;
            const next = new URL(value, url);
            if (next.origin === new URL(url).origin && next.pathname.startsWith(chapterPath + '-10-')) pages.add(next.href);
        }
        const documents = await Promise.all([...pages].map(async page => ({ page, doc: page === url ? first : this.dom(await this.text(page)) })));
        const images = documents.flatMap(({page,doc}) => Array.from(doc.querySelectorAll('img.mangaread-manga-pic')).flatMap(image => {
            const src = image.getAttribute('data-src') || image.getAttribute('src');
            return src ? [this.absolute(src, page)] : [];
        }));
        if (!images.length) throw new Error('NovelCool: no se encontraron imágenes en este capítulo.');
        return this.pages([...new Set(images)], url);
    }
}
